import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './context/AuthProvider';
import { ThemeProviderComponent } from './context/ThemeContext';


import './i18n/i18n';
import { I18nextProvider } from 'react-i18next';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <I18nextProvider>
      <AuthProvider>
        <ThemeProviderComponent>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </ThemeProviderComponent>
      </AuthProvider>
    </I18nextProvider>  
  </React.StrictMode>
);

reportWebVitals();
